import { getVideoMetadata } from "@/app/actions";
import { CustomCategory } from "@/components/category";
import Duration from "@/components/duration";
import FormatDate from "@/components/format-date";
import TeaserHeading from "@/components/teaser-heading";
import TeaserLinkedContent from "@/components/teaser-linked-content";
import VideoThumbnail from "@/components/video-thumbnail";
import { Content } from "@/services/content/types";
import classNames from "classnames";
import Link from "next/link";

type MediumProps = {
  play: Content.Play;
  hideCategory?: boolean;
  showLinkedContent?: boolean;
  hideDownPull?: boolean;
  showLeftLine?: boolean;
};

const Medium = async (props: MediumProps) => {
  const videoId =
    props.play.fields.quickchannelIds?.[0] || props.play.fields.videos?.[0];

  const videoMetadata = videoId
    ? await getVideoMetadata({
        qbrick: props.play.fields.videos?.[0],
        quickchannel: props.play.fields.quickchannelIds?.[0],
      })
    : null;

  const title = props.play.fields.teaserTitle || props.play.fields.title;
  const image = props.play.fields.teaserImage || props.play.fields.image;
  const playShow = props.play.fields["play-show"];
  const hasLinkedContent = Boolean(props.play.fields.linkedContent?.length);

  return (
    <div className="bg-static-black-400 h-full">
      <Link
        href={`/play/${props.play.fields.slug}`}
        className={classNames("group block relative  overflow-hidden", {})}
      >
        <div className="relative">
          <VideoThumbnail
            thumbnailImage={image}
            fallbackUrl={videoMetadata?.thumbnail}
          />

          <Duration duration={videoMetadata?.duration} />
        </div>
        <div
          className={classNames("p-4", {
            "pb-0": hasLinkedContent && props.showLinkedContent,
          })}
        >
          {playShow && !props.hideCategory && (
            <CustomCategory
              inverted
              color="Play"
              name={playShow.fields.title}
            />
          )}

          {title && (
            <TeaserHeading
              text={title}
              className="text-xl text-static-white font-semibold"
            />
          )}

          <div className="text-black-100 text-sm mt-2 font-bold">
            <FormatDate
              date={
                props.play.fields.broadcastStart || props.play.sys.createdAt
              }
            />
          </div>
        </div>
      </Link>
      {hasLinkedContent && props.showLinkedContent && (
        <div className="" data-mode="dark">
          <TeaserLinkedContent
            linkedContent={props.play.fields.linkedContent}
            showLinkedContent={props.showLinkedContent}
            compactMode={true}
            darkMode={true}
          />
        </div>
      )}
    </div>
  );
};

export default Medium;
